export default "__VITE_ASSET__Bxq3BLPK__"